import { Link } from "react-router-dom";

export interface BreadcrumbItem {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: BreadcrumbItem[] }) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center flex-wrap gap-1.5 text-xs md:text-sm text-secondary-500">
      {items.map((item, i) => (
        <span key={i} className="flex items-center gap-1.5">
          {i > 0 && <span className="flex items-center justify-center w-4 h-4 text-secondary-300"><i className="ri-arrow-right-s-line" aria-hidden="true"></i></span>}
          {item.to ? (
            <Link to={item.to} className="hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-800 whitespace-nowrap">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}